var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.333H9.583A4.589 4.589 0 0 1 5 18.75V9.583A4.589 4.589 0 0 1 9.583 5h9.167a4.589 4.589 0 0 1 4.583 4.583v9.167a4.589 4.589 0 0 1-4.583 4.583zm-9.167-16.5a2.75 2.75 0 0 0-2.75 2.75v9.167a2.75 2.75 0 0 0 2.75 2.75h9.167a2.75 2.75 0 0 0 2.75-2.75V9.583a2.75 2.75 0 0 0-2.75-2.75H9.583zM27 22.417V10.5a.917.917 0 0 0-1.833 0v11.917a2.75 2.75 0 0 1-2.75 2.75H10.5a.916.916 0 1 0 0 1.833h11.917A4.59 4.59 0 0 0 27 22.417z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.422c0053a952454aaa26c20a84fd7047.svg";
export { ForwardRef as ReactComponent };